import Link from 'next/link'
import styled from 'styled-components'

export const Wrapper = styled(Link)`
  border: 1px solid #ededed;
  border-radius: 10px;
  display: flex;
  width: fit-content;
  max-width: 240px;
  width: 100%;
  text-decoration: none;
  color: var(--brand-secondary);

  @media (max-width: 767px) {
    max-width: unset;
    border-radius: 0 8px 8px 0;
  }
`
export const Thumbnail = styled.div<{ image: string }>`
  background-position: center center;
  background-size: cover;
  background-image: ${({ image }) => `url(${image});`}
  height: 84px;
  width: 84px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  
  @media (max-width: 767px) {
    width: 45px;
    height: 55px;
    flex-shrink: 0;
    border-radius: 8px 0 0 8px;
  }
`
export const Title = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  line-height: 1.2;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`
